export const billingTransactionRefetchQueries = [
  'getPageOfBillingTransactions',
  'getBillingTransactionTotals'
];
export default billingTransactionRefetchQueries;
